import React from "react";
import { Card, CardBody} from "reactstrap";
import MessageApexbar from "../AllCharts/apex/MessageApexbar/MessageApexbar";

const MessageActivity = () => {
    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <div className="d-flex align-items-start">
                        <div className="flex-grow-1 overflow-hidden">
                            <h5 className="card-title text-truncate mb-4">Messages Per Month</h5>
                        </div>
                    </div>
                    <div>
                        <div id="chart-column" className="apex-charts" dir="ltr">
                            <MessageApexbar />
                        </div>
                    </div>

                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default MessageActivity;